import { initializeApp } from 'firebase/app';
import {
  getFirestore, doc, getDoc, setDoc, updateDoc, onSnapshot,
  collection, addDoc, query, orderBy, getDocs, deleteDoc,
  where, Timestamp, enableIndexedDbPersistence, limit, startAfter,
  writeBatch, increment, arrayUnion, arrayRemove, serverTimestamp,
} from 'firebase/firestore';
import {
  getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  onAuthStateChanged, signOut, sendPasswordResetEmail,
} from 'firebase/auth';
import { getMessaging, getToken, onMessage as onFCMMessage } from 'firebase/messaging';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyCxaXNvebC1AoGwx-CviMtmP5CnkQQU4Pk',
  authDomain: 'quest-life-4fa52.firebaseapp.com',
  databaseURL: 'https://quest-life-4fa52-default-rtdb.firebaseio.com',
  projectId: 'quest-life-4fa52',
  storageBucket: 'quest-life-4fa52.firebasestorage.app',
  messagingSenderId: '369317692262',
  appId: '1:369317692262:web:32c38546b30c8db21b7ea7',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');

let _messaging = null;
try {
  _messaging = getMessaging(app);
} catch {
  _messaging = null;
}
export const messaging = _messaging;

export async function enableOfflinePersistence() {
  try {
    await enableIndexedDbPersistence(db);
  } catch (e) {
    // Multi-tab or unsupported — silent fail
  }
}

export const fb = {
  db, auth, messaging, functions,
  doc, getDoc, setDoc, updateDoc, onSnapshot,
  collection, addDoc, query, orderBy, getDocs, deleteDoc,
  where, Timestamp, limit, startAfter,
  writeBatch, increment, arrayUnion, arrayRemove, serverTimestamp,
  signIn: signInWithEmailAndPassword,
  signUp: createUserWithEmailAndPassword,
  onAuth: onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
  getToken, onFCMMessage,
  httpsCallable: (name) => httpsCallable(functions, name),
};

// Backwards compatibility with legacy code that uses window.fb
if (typeof window !== 'undefined') {
  window.fb = fb;
}
